import { __rest } from "tslib";
import * as React from 'react';
import Upload from './Upload';
const Dragger = React.forwardRef((_a, ref) => {
    var { style, height } = _a, restProps = __rest(_a, ["style", "height"]);
    return (React.createElement(Upload, Object.assign({ ref: ref }, restProps, { type: "drag", style: Object.assign(Object.assign({}, style), { height }) })));
});
if (process.env.NODE_ENV !== 'production') {
    Dragger.displayName = 'Dragger';
}
export default Dragger;
